import { Grid } from "@mui/material";
import { Container } from "@mui/system";
import { useEffect, useState } from "react";
import ImagevitaleauVerrieresAntony from "../../src/assets/images/activites/Vitaleau-Montage-Generique.webp";
import { GoPloof } from "../components/organisms/GoPloof";
import MetaMaster from "../components/utils/MetaMaster";
import { Button } from "../stories/atoms/Button";
import { HeroInner } from "../stories/organisms/HeroInner";

export default function Tarifs() {
    const [piscine, setPiscine] = useState();
    const [piscineIsLoading, setPiscineIsLoading] = useState(true);
    const [arianeItem] = useState([
        ["/", "Vital'Eau"],
        ["/tarifs", "Tarifs"],
    ]);

    useEffect(() => {
        setPiscine({
            tarifs_bebes: {
                type: "Bébés nageurs",
                soustitre: "de 4 mois 1/2 à 3 ans",
                tarifs_formules: [
                    {
                        formule: [
                            {
                                titre: "Séance à l’unité (si disponibilité), uniquement sur rendez-vous",
                                prix: "50 €",
                            },
                            {
                                titre: "Forfait année scolaire tous les samedis",
                                prix: "480 €",
                                soustitre: "Inscriptions tout au long de l'année en fonction des places disponibles",
                            },
                        ],
                    },
                ],
            },
            tarifs_enfants: {
                type: "Enfants",
                soustitre: "leur école de natation, de 3 à 13 ans",
                tarifs_formules: [
                    {
                        titre: "Section découverte (à partir de 3 ans avec un parent)",
                        formule: [
                            {
                                titre: "Séance à l’unité (si disponibilité), uniquement sur rendez-vous",
                                prix: "50 €",
                            },
                            {
                                titre: "Forfait année scolaire tous les samedis",
                                prix: "530 €",
                                soustitre: "Inscriptions tout au long de l'année en fonction des places disponibles",
                            },
                            // {
                            //     titre: "Forfait 16 séances consécutives tous les samedis",
                            //     prix: "265 €",
                            //     soustitre: "Inscriptions tout au long de l'année en fonction des places disponibles",
                            // },
                        ],
                    },
                    {
                        titre: "Section initiation (à partir de 4 ans)",
                        formule: [
                            {
                                titre: "Abonnement année scolaire",
                                prix: "420 €",
                                soustitre: "1 séance par semaine, hors vacances et jours fériés",
                            },
                        ],
                    },
                    {
                        titre: "Section perfectionnement (à partir de 6 ans)",
                        formule: [
                            {
                                titre: "Abonnement année scolaire",
                                prix: "395 €",
                                soustitre: "1 séance par semaine, hors vacances et jours fériés",
                            },
                        ],
                    },
                    {
                        titre: "Section apprentissage",
                        formule: [
                            // {
                            //     titre: "Du 6 mai au 4 juillet 2026",
                            //     prix: "176 €",
                            //     soustitre: "8 séances (pas de séances le mercredi 13 mai, et samedi 16 mai)",
                            // },
                            {
                                titre: "Du 2 septembre au 17 octobre 2026",
                                prix: "154 €",
                                soustitre: "7 séances",
                            },
                            {
                                titre: "Du 4 novembre au 19 décembre 2026 ",
                                prix: "154 €",
                                soustitre: "7 séances",
                            },
                            {
                                titre: "Du 6 janvier au 6 février 2027",
                                prix: "110 €",
                                soustitre: "5 séances",
                            },
                            {
                                titre: "Du 24 février au 3 avril 2027",
                                prix: "132 €",
                                soustitre: "6 séances",
                            },
                            {
                                titre: "Du 21 avril au 29 mai 2027",
                                prix: "110 €",
                                soustitre: "5 séances (pas de séances le mercredi 5 mai, et samedi 8 mai)",
                            },
                            {
                                titre: "Du 2 juin au 3 juillet 2027",
                                prix: "110 €",
                                soustitre: "5 séances",
                            },
                        ],
                    },
                    {
                        titre: "Les stages 100% natation et apprentissage",
                        formule: [
                            {
                                titre: "4 séances",
                                prix: "110 €",
                                soustitre:
                                    "Du lundi au jeudi, pendant toutes les vacances scolaires et dès la mi-juin pour l'été. Nous consulter pour les horaires.",
                            },
                        ],
                    },
                ],
            },
            tarifs_adultes: {
                type: "Adultes",
                soustitre: "",
                tarifs_formules: [
                    {
                        titre: "Formules annuelles",
                        formule: [
                            {
                                titre: "1 séance fixe par semaine - Année scolaire - Hors vacances",
                                prix: "370 €",
                                soustitre:
                                    "Pour la formule annuelle, l'inscription se fait au club, par téléphone au 01 64 47 05 18, ou en faisant une demande par SMS au 06 11 73 14 12 (nous vous rappellerons)",
                            },
                            // {
                            //     titre: "2 séances fixes par semaine - Année scolaire - Hors vacances",
                            //     prix: "595 €",
                            //     soustitre:
                            //         "Pour la formule annuelle, l'inscription se fait au club, par téléphone au 01 64 47 05 18, ou en faisant une demande par SMS au 06 11 73 14 12 (nous vous rappellerons)",
                            // },
                        ],
                    },
                    {
                        titre: "Carnets formules liberté",
                        formule: [
                            {
                                titre: "1 séances",
                                prix: "25 €",
                            },
                            {
                                titre: "5 séances (valable 2 mois)",
                                prix: "110 €",
                            },
                            {
                                titre: "10 séances (valable 5 mois)",
                                prix: "190 €",
                            },
                            {
                                titre: "20 séances (valable 8 mois)",
                                prix: "360 €",
                            },
                            {
                                titre: "30 séances (valable 10 mois)",
                                prix: "450 €",
                            },
                            {
                                titre: "40 séances (valable 1 an)",
                                prix: "560 €",
                            },
                        ],
                    },
                    {
                        titre: "Carnets formules heures creuses",
                        formule: [
                            {
                                titre: "10 séances (valable 4 mois)",
                                prix: "150 €",
                            },
                            {
                                titre: "20 séances (valable 6 mois)",
                                prix: "280 €",
                                soustitre:
                                    "Pour les carnets, les rendez-vous peuvent être pris 15 jours à l’avance. Attention : pour des raisons d’organisation, en semaine, toutes les séances non décommandées au-delà de 12 h à l’avance seront décomptées. Pour le dimanche, le délai d’annulation est de 24 h.",
                            },
                        ],
                    },
                ],
            },
        });
        setPiscineIsLoading(false);
    }, []);

    return (
        <>
            {!piscineIsLoading && (
                <>
                    <MetaMaster title={"Vital'eau - Tarifs"} />
                    <HeroInner arianeItem={arianeItem} imagesSwiper={[ImagevitaleauVerrieresAntony]} />
                    <section className="section-show-pool-home" id="accueil-histoire">
                        <Container maxWidth="xl">
                            <Grid container>
                                <Grid item lg={12} md={12} sm={12} xs={12}>
                                    <div>
                                        <h1 className="accueil-histoire-titre h1-inner" data-title="Tarifs">
                                            Tarifs
                                        </h1>
                                    </div>
                                </Grid>
                            </Grid>
                        </Container>
                    </section>
                    <section className="section-vitaleau-tarif-piscine tempalge-page-tarifs" id="tarifs">
                        <Container maxWidth="xl">
                            <Grid container>
                                <Grid item xs={12}>
                                    <div className="bloc_info_tarifs">
                                        {piscine.tarifs_bebes && (
                                            <div className="containerTarifs" id="tarifs-bebes">
                                                <h3>{piscine.tarifs_bebes.type}</h3>
                                                {piscine.tarifs_bebes.soustitre && <p className="baseline">{piscine.tarifs_bebes.soustitre}</p>}
                                                {piscine.tarifs_bebes.tarifs_formules.map((tarif) => (
                                                    <>
                                                        <h4>
                                                            {tarif.titre} {tarif.soustitre && <span>{tarif.soustitre}</span>}
                                                        </h4>
                                                        {tarif.formule && (
                                                            <>
                                                                {tarif.formule.map((item, index) => (
                                                                    <p className="tarif" key={index}>
                                                                        <span className="tarif-titre">
                                                                            <span>{item.titre}</span>
                                                                            {item.soustitre && (
                                                                                <span className="tarif-soustitre">{item.soustitre}</span>
                                                                            )}
                                                                        </span>
                                                                        <span className="tarif-prix">{item.prix + " "}</span>
                                                                    </p>
                                                                ))}
                                                            </>
                                                        )}
                                                    </>
                                                ))}
                                            </div>
                                        )}
                                        <div className="containerTarifs" id="tarifs-enfants" style={{ paddingBottom: "64px" }}>
                                            <h3 className="pt64">
                                                <span className="">{piscine.tarifs_enfants.type} </span>
                                            </h3>
                                            {piscine.tarifs_enfants.soustitre && <p className="baseline">{piscine.tarifs_enfants.soustitre}</p>}
                                            {piscine.tarifs_enfants.tarifs_formules.map((tarif) => (
                                                <>
                                                    <h4>
                                                        {tarif.titre} <span>{tarif.soustitre}</span>
                                                    </h4>
                                                    {tarif.formule && (
                                                        <>
                                                            {tarif.formule.map((item, index) => (
                                                                <>
                                                                    <p className="tarif" key={index}>
                                                                        <span className="tarif-titre">
                                                                            <span>{item.titre}</span>
                                                                            {item.soustitre && (
                                                                                <span className="tarif-soustitre">{item.soustitre}</span>
                                                                            )}
                                                                        </span>
                                                                        <span className="tarif-prix">
                                                                            {item.prix + " "}
                                                                            <span className="textstroke">{item.promo}</span>
                                                                        </span>
                                                                    </p>
                                                                </>
                                                            ))}
                                                        </>
                                                    )}
                                                </>
                                            ))}
                                        </div>
                                        <div className="containerTarifs" id="tarifs-adultes">
                                            <h3>{piscine.tarifs_adultes.type}</h3>
                                            {piscine.tarifs_adultes.soustitre && <p className="baseline">{piscine.tarifs_adultes.soustitre}</p>}
                                            {piscine.tarifs_adultes.tarifs_formules.map((tarif) => (
                                                <>
                                                    <h4>
                                                        {tarif.titre} <span>{tarif.soustitre}</span>
                                                    </h4>
                                                    {tarif.formule && (
                                                        <>
                                                            {tarif.formule.map((item, index) => (
                                                                <>
                                                                    <p className="tarif" key={index}>
                                                                        <span className="tarif-titre">
                                                                            <span>{item.titre}</span>
                                                                            {item.soustitre && (
                                                                                <span className="tarif-soustitre">{item.soustitre}</span>
                                                                            )}
                                                                        </span>
                                                                        <span className="tarif-prix">
                                                                            {item.prix + " "}
                                                                            <span className="textstroke">{item.promo}</span>
                                                                        </span>
                                                                    </p>
                                                                </>
                                                            ))}
                                                        </>
                                                    )}
                                                </>
                                            ))}
                                        </div>
                                    </div>
                                </Grid>
                            </Grid>
                        </Container>
                    </section>
                    <GoPloof />
                    <section className="section-contact">
                        <Container maxWidth="xl">
                            <Grid container>
                                <Grid item lg={12} md={12} sm={12} xs={12}>
                                    <div>
                                        <h2 className="accueil-histoire-titre" data-title="Des questions ?">
                                            Des questions ?
                                        </h2>
                                        <p className="text-center">
                                            Besoin d’informations ? Envie d’en savoir plus sur nos activités et notre fonctionnement ? <br />
                                            Nous sommes disponibles pour répondre à toutes vos demandes !
                                        </p>
                                        <br />
                                        <br />
                                        <Button label="Nous contacter" style={{ width: "fit-content", margin: "0 auto" }} primary href={"/contact"} />
                                    </div>
                                </Grid>
                            </Grid>
                        </Container>
                    </section>
                </>
            )}
        </>
    );
}
